import styled from "styled-components";

const ImageTitle = styled.div`
  font-weight: 800;
  text-transform: lowercase;
  font-size: 30px;
  margin-top: 5px;

  @media (max-width: 1599px) {
    font-size: 20px;
  }
  @media (max-width: 1199px) {
    font-size: 16px;
  }
  @media (max-width: 575px) {
    line-height: normal;
    font-size: 14px;
  }
`;
export default ImageTitle;
